// Case document upload rules (client portal + staff uploads / Upload on behalf).
// Mirrors CaseDocumentServiceImpl.assertValidAttachment, which is authoritative.

export const MAX_DOCUMENT_MB = 100;
export const MAX_DOCUMENT_BYTES = MAX_DOCUMENT_MB * 1024 * 1024;

const ALLOWED_DOCUMENT_EXTENSIONS = [
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'csv',
  'jpg',
  'jpeg',
  'png',
  'zip',
];

function formatMb(bytes: number): string {
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

// Returns an error message, or '' when the file can be uploaded.
export function validateDocumentFile(file: File | null | undefined): string {
  if (!file) return 'Please choose a file to upload.';
  if (file.size === 0) return 'This file is empty. Please choose another file.';
  const name = file.name || '';
  const ext = name.includes('.') ? name.substring(name.lastIndexOf('.') + 1).toLowerCase() : '';
  if (!ALLOWED_DOCUMENT_EXTENSIONS.includes(ext)) {
    return `Unsupported file type${ext ? ` '.${ext}'` : ''}. Allowed: PDF, DOC, DOCX, XLS, XLSX, CSV, JPG, JPEG, PNG, ZIP.`;
  }
  if (file.size > MAX_DOCUMENT_BYTES) {
    return `This file is ${formatMb(file.size)}. Documents must be ${MAX_DOCUMENT_MB} MB or smaller.`;
  }
  return '';
}
